import type { Overrides } from '@material-ui/core/styles/overrides';

import MuiCheckbox from './MuiCheckbox';

const createOverrides: Overrides = {
  MuiCheckbox,
};
export default createOverrides;
